export type Random = () => number

const HEX = '0123456789abcdef'
const BASE58 = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

/** Seeded generator, so a scene's first frame is identical on the server and in the browser. */
export const createRandom = (seed: number): Random => {
    let state = seed >>> 0

    return () => {
        state = (state + 0x6d2b79f5) >>> 0
        let t = state
        t = Math.imul(t ^ (t >>> 15), t | 1)
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296
    }
}

export const randomInt = (max: number, random: Random = Math.random): number => {
    return Math.floor(random() * max)
}

export function shuffle<T>(items: readonly T[], random: Random = Math.random): T[] {
    const result = [...items]

    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(random() * (i + 1))
        const swap = result[i]
        result[i] = result[j]
        result[j] = swap
    }

    return result
}

export const range = (length: number, start = 0): number[] => {
    return Array.from({ length }, (_, index) => index + start)
}

export const randomHex = (length: number, random: Random = Math.random): string => {
    let out = ''
    for (let i = 0; i < length; i++) out += HEX[Math.floor(random() * 16)]
    return out
}

export const randomBase58 = (length: number, random: Random = Math.random): string => {
    let out = ''
    for (let i = 0; i < length; i++) out += BASE58[Math.floor(random() * BASE58.length)]
    return out
}
